import { createContext, useCallback, useRef } from "react";

export const GuardarPruebaContext = createContext(null);

export function GuardarPruebaProvider({ children }) {
    const registryRef = useRef(new Map());

    const registerRep = useCallback((key, getter, hasData) => {
        registryRef.current.set(key, { getter, hasData });
    }, []);

    const unregisterRep = useCallback((key) => {
        registryRef.current.delete(key);
    }, []);

    const collectReps = useCallback(() => {
        return Array.from(registryRef.current.entries()).map(([key, { getter, hasData }]) => ({
            key,
            hasData,
            getPayload: getter,
        }));
    }, []);

    const value = {
        registerRep,
        unregisterRep,
        collectReps,
    };

    return <GuardarPruebaContext.Provider value={value}>{children}</GuardarPruebaContext.Provider>;
}
